export default __webpack_public_path__ + "static/media/(17).af859f54.jpeg";